import { NgClass, NgTemplateOutlet } from "@angular/common";
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ContentChildren,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    QueryList,
    ViewChild,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { EventService } from "~app/common/services/cqs/event.service";
import { MapTabEvents } from "./events/map-tab-events";
import { MapTabModeChangedEvent } from "./events/mapTabModeChangedEvent";
import { MapWidgetTabComponent } from "./map-widget-tab/map-widget-tab.component";
import { MapTabEventService } from "./services/MapTabEventService";

@Component({
    selector: "rask-map-tab-widget",
    templateUrl: "./map-tab-widget.component.html",
    styleUrls: ["./map-tab-widget.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        NgTemplateOutlet,
        NgbTooltip
    ]
})
export class MapTabWidgetComponent implements AfterViewInit {
    isOpen = false;

    @Output() open: EventEmitter<string> = new EventEmitter();
    openTab: string;
    @ViewChild("tabContainer", { read: ElementRef }) tabContainer: ElementRef;
    @ContentChildren(MapWidgetTabComponent) tabs: QueryList<MapWidgetTabComponent>;

    private readonly cdRef = inject(ChangeDetectorRef);
    private readonly eventService = inject(EventService);
    private readonly mapTabEventService = inject(MapTabEventService);

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("startTab") set list(val: string) {
        if (val !== undefined) {
            this.isOpen = true;
            this.openTab = val;
        }
    }

    ngAfterViewInit() {
        this.cdRef.detectChanges();
    }

    toggleWidget(tab: MapWidgetTabComponent) {
        if (tab.disabled) {
            return;
        }
        this.closeOtherTabs(tab.id);
        tab.isOpen = !tab.isOpen;
        if (tab.isOpen) {
            this.openTab = tab.id;
            this.open.emit(tab.id);
            this.isOpen = true;
        } else {
            this.isOpen = false;
            this.openTab = null;
        }
        this.eventService.emit<MapTabModeChangedEvent>(new MapTabModeChangedEvent(tab.id));
        this.mapTabEventService.emit(MapTabEvents.TabChanged, tab.id);
    }

    private closeOtherTabs(id: string) {
        this.tabs.forEach((tab: MapWidgetTabComponent) => {
            if (tab.id !== id) {
                tab.isOpen = false;
            }
        });
    }
}
